import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Twitter = function Twitter(props) {
  useDeprecatedComponentWarning({
    component: 'Twitter'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M2048 367q-84 127-209 218v55q0 140-35.5 281.5t-102 275T1531 1446t-233 202.5-297.5 136.5-355.5 50q-379 0-645-171 46 7 100 7 140 0 274-54t247-145q-135-1-243.5-83.5T230 1180q42 8 78 8 58 0 112-15-145-29-241-144.5T83 761v-5q90 49 190 52-87-58-137.5-150T85 460q0-103 57-204 158 192 382 304.5T1007 687q-9-39-9-97 0-174 122.5-296.5T1417 171q179 0 309 132 143-29 265-102-48 152-185 233 125-14 242-67z"
  }));
};

Twitter.displayName = 'Twitter';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Twitter.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Twitter;